import { render, staticRenderFns } from "./relic-detail-report.vue?vue&type=template&id=c3fb7662&scoped=true"
import script from "./relic-detail-report.vue?vue&type=script&lang=js"
export * from "./relic-detail-report.vue?vue&type=script&lang=js"
import style0 from "./relic-detail-report.vue?vue&type=style&index=0&id=c3fb7662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fb7662",
  null
  
)

export default component.exports